
import React, { useState } from 'react';

const WhatsAppFloat: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  const whatsappNumber = "+14697380696";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello! I'm interested in your consulting services and would like to get help.`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Text Label */}
        <div className={`bg-white text-black px-4 py-2 rounded-full shadow-lg mr-3 font-medium text-sm whitespace-nowrap transition-all duration-300 ${
          isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
        }`}>
          Chat with us
        </div>

        {/* WhatsApp Button */}
        <div className="relative">
          <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-2xl hover:bg-red-700 transition-all duration-300 hover:scale-110 cursor-pointer animate-pulse hover:animate-none">
            <i className="ri-whatsapp-line text-2xl text-white"></i>
          </div>
          
          {/* Pulse Effect */}
          <div className="absolute inset-0 w-16 h-16 bg-red-600 rounded-full animate-ping opacity-20"></div>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppFloat;
